import { useEffect, useRef, useState } from 'react';
import { DailyBonusBadgeProps } from './types';
import { getTimeLabel, TIME_LEFT_INTERVAL } from './utils';

export const useDailyBonusBadge = ({
  targetDate,
  onTargetDateReach,
}: DailyBonusBadgeProps) => {
  const [timeLeftLabel, setTimeLeftLabel] = useState<string>('');
  const [secondsLeft, setSecondsLeft] = useState<number>();

  const updateSecondsIntervalRef = useRef<any>();

  const updateRemainingTime = () => {
    if (!targetDate) return;
    const remainingTime = targetDate.getTime() - new Date().getTime();
    setSecondsLeft(remainingTime);

    return remainingTime;
  };

  useEffect(() => {
    if (!targetDate) return;

    const remainingTime = updateRemainingTime();

    if (remainingTime && remainingTime <= 0) {
      return;
    }

    updateSecondsIntervalRef.current = setInterval(
      () => setSecondsLeft((prev) => (prev ? prev - TIME_LEFT_INTERVAL : prev)),
      TIME_LEFT_INTERVAL,
    );
    return () => {
      if (updateSecondsIntervalRef.current)
        clearInterval(updateSecondsIntervalRef.current);
    };
  }, [targetDate]);

  useEffect(() => {
    if (secondsLeft === undefined) return;

    if (secondsLeft <= 0) {
      setTimeLeftLabel('');
      onTargetDateReach?.();

      if (updateSecondsIntervalRef.current)
        clearInterval(updateSecondsIntervalRef.current);
    } else {
      setTimeLeftLabel(getTimeLabel(secondsLeft));
    }
  }, [secondsLeft]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        updateRemainingTime();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [targetDate]);

  return {
    timeLeftLabel,
  };
};
